import { inject, Injectable } from '@angular/core';
import { EntityService } from '../../core/services/entity.service';
import { createEntityState, GenericEntityStateClass } from '../../core/state/entity.state';
import { SubjectEntityService } from '../../subject/services/subject.entity.service';
import { AssetEntity } from '../asset.entity';

export const STATE_NAME = 'assetEntity';

// Create the NGXS state
export const AssetEntityState: GenericEntityStateClass<AssetEntity> =
  createEntityState<AssetEntity>(STATE_NAME);

@Injectable({ providedIn: 'root' })
export class AssetEntityService extends EntityService<AssetEntity> {
  private subjectEntityService = inject(SubjectEntityService);

  constructor() {
    super();
    this.resourceType = 'assets';
    this.stateClass = AssetEntityState;

    this.registerRelation('subjects', this.subjectEntityService);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  allByQuery(query: Record<string, any> = {}) {
    const stateClass = this.stateClass;
    const sliceName = STATE_NAME;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (storeState: any): AssetEntity[] => {
      const slice = storeState[sliceName];
      return stateClass.allByQuery(slice, { query });
    };
  }
}
